"use client";

import { useContext } from "react";
import getLanguage from "../components/LinkComponent/helpers/getLanguage";
import getSiteInfo from "../components/LinkComponent/helpers/getSiteInfo";
import SiteInfoContext, { type SiteInfo } from "./SiteInfoContext";

// Prefer the server-provided context; the cookie/location fallback keeps
// trees rendered outside the root provider (tests, storybook) working, at
// the cost of the old SSR/client mismatch there.
const useSiteInfo = (): SiteInfo => {
  const context = useContext(SiteInfoContext);
  if (context) {
    return context;
  }
  const { site, isBridgeSite, defaultLang } = getSiteInfo();
  return {
    site,
    isBridgeSite,
    defaultLang,
    language: getLanguage(),
    domain: typeof window !== "undefined" ? window.location.host : "",
  };
};

export default useSiteInfo;
